<script lang="ts">
    import src from './svg/directions_car_24dp_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<TemplateIcon {src} {scale} alt="" on:click />
